"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regenerateCode = exports.getRegenerateCodePath = void 0;
const axios_client_1 = require("@invivodf/axios-client");
const getRegenerateCodePath = (checkoutId) => `/v2/bff/appro/checkouts/${checkoutId}/regenerateCode`;
exports.getRegenerateCodePath = getRegenerateCodePath;
const regenerateCode = (client) => async ({ checkoutId }) => {
    return (0, axios_client_1.httpResultWrapper)(() => client.post((0, exports.getRegenerateCodePath)(checkoutId)));
};
exports.regenerateCode = regenerateCode;
